import { inject, Injectable } from '@angular/core';
import { GridViewDialogData, ViewActionType } from '../../types';

import { Store } from '@ngrx/store';
import { GRID_VIEW_DIALOG_ACTIONS } from '../../actions';

@Injectable()
export class GridViewDialogService<T> {
  private readonly _store = inject(Store);

  open(dialogData: GridViewDialogData<T>, _: ViewActionType) {
    this._store.dispatch(
      GRID_VIEW_DIALOG_ACTIONS.openGridViewDialog({
        data: dialogData,
      }),
    );
  }

  close(): void {
    this._store.dispatch(GRID_VIEW_DIALOG_ACTIONS.closeGridViewDialog());
  }
}
